import { FC, useRef } from "react";
import { solutionsData } from "./constant";
import { Link } from "react-router-dom";
import { useClickOutSideComponent } from "helpers/screenHelpers";
import { NavigationLink } from "./NavigationLink";

interface Props {
  onClose: () => void;
  triggerRef: React.RefObject<HTMLButtonElement>;
}

export const SolutionsModal: FC<Props> = ({ onClose, triggerRef }) => {
  const modalRef = useRef<HTMLDivElement>(null);

  useClickOutSideComponent([modalRef, triggerRef], onClose);

  return (
    <div ref={modalRef}>
      <div className="hidden md:grid grid-cols-2 gap-x-12 gap-y-4 absolute top-full left-0 lg:left-1/2 lg:-translate-x-1/2 mt-2 bg-white w-[600px] cursor-pointer p-4 shadow-md border border-[#E5EAF0] rounded-xl">
        {solutionsData.map((solution) => (
          <Link
            key={solution.path}
            to={solution.path}
            className="flex items-center gap-3"
            onClick={onClose}
          >
            <img src={solution.icon} alt="" className="w-8 h-8" />
            <div className="text-sm">
              <p className="text-blueShades-6 font-SatoshiBold">
                {solution.name}
              </p>
              <p className="text-ashShade-16 font-SatoshiRegular whitespace-nowrap">
                {solution.description}
              </p>
            </div>
          </Link>
        ))}
      </div>

      <div className="md:hidden flex flex-col gap-8">
        {solutionsData.map((solution) => (
          <NavigationLink
            to={solution.path}
            label={solution.name}
            key={solution.name}
            onClose={onClose}
          />
        ))}
      </div>
    </div>
  );
};
